import { BaseService } from '../common/service/base.service';

export class BaseTradeService extends BaseService {
  constructor(apiVersion: string = 'v1') {
    super(process.env.REACT_APP_TRADE_API_URL || '', apiVersion);
  }
}
